// extracted by mini-css-extract-plugin
export default {"reportHeader":"blockBusinessCreditReport_reportHeader__QUeYG","reportHeaderTitle":"blockBusinessCreditReport_reportHeaderTitle__PRcHp"};